import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import { get, isEqual } from 'lodash';
import {
    USER_UPDATE_FAILURE,
    USER_UPDATE_LOAD,
    USER_UPDATE_SUCCESS,
    TIMEZONE_UPDATE_FAILURE,
    TIMEZONE_UPDATE_LOAD,
    TIMEZONE_UPDATE_SUCCESS,
    TIMEZONE_GET_FAILURE,
    TIMEZONE_GET_LOAD,
    TIMEZONE_GET_SUCCESS
} from './userSettingsActions';

const initialState = {
    user: null,
    error: null,
    loading: false,
    timezone: 'UTC'
};

export default function reducer(state = initialState, action) {
    let newState;

    switch (action.type) {
        case USER_UPDATE_FAILURE:
            newState = {
                ...state,
                error: action.error,
                loading: false
            };

            return isEqual(state, newState) ? state : newState;

        case USER_UPDATE_LOAD:
            newState = {
                ...state,
                loading: true,
                isSuccessful: false
            };

            return isEqual(state, newState) ? state : newState;

        case USER_UPDATE_SUCCESS:
            newState = {
                ...state,
                loading: false,
                isSuccessful: true
            };

            return isEqual(state, newState) ? state : newState;

        case TIMEZONE_UPDATE_FAILURE:
            newState = {
                ...state,
                updateTimezoneError: action.error,
                updateTimezoneLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case TIMEZONE_UPDATE_LOAD:
            newState = {
                ...state,
                updateTimezoneError: null,
                updateTimezoneLoading: true,
                isUpdateTimezoneSuccessful: false
            };

            return isEqual(state, newState) ? state : newState;

        case TIMEZONE_UPDATE_SUCCESS:
            newState = {
                ...state,
                timezone: action.timezone,
                timezoneUpdateLoading: false,
                isUpdateTimezoneSuccessful: true
            };

            return isEqual(state, newState) ? state : newState;

        case TIMEZONE_GET_FAILURE:
            newState = {
                ...state,
                getTimezoneError: action.error,
                getTimezoneLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case TIMEZONE_GET_LOAD:
            newState = {
                ...state,
                getTimezoneError: null,
                getTimezoneLoading: true,
                isGetTimezoneSuccessful: false
            };

            return isEqual(state, newState) ? state : newState;

        case TIMEZONE_GET_SUCCESS:
            newState = {
                ...state,
                getTimezoneLoading: false,
                isGetTimezoneSuccessful: true,
                timezone: action.timezone
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getSettingsEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'userSettings')
);

export const getIsUpdateUserLoading = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'loading')
);

export const getIsUpdateUserSuccessful = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'isSuccessful')
);

export const getUpdateUserError = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'error')
);

export const getUpdateUserErrorMessage = createSelector(
    getUpdateUserError,
    (entity) => get(entity, 'message')
);

export const getUser = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'user')
);

export const getIsUpdateTimezoneLoading = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'updateTimezoneLoading')
);

export const getIsUpdateTimezoneSuccessful = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'isUpdateTimezoneSuccessful')
);

export const getUpdateTimezoneError = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'updateTimezoneError')
);

export const getUpdateTimezoneErrorMessage = createSelector(
    getUpdateTimezoneError,
    (entity) => get(entity, 'message')
);
export const getIsGetTimezoneLoading = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'getTimezoneLoading')
);

export const getIsGetTimezoneSuccessful = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'isGetTimezoneSuccessful')
);

export const getGetTimezoneError = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'getTimezoneError')
);

export const getGetTimezoneErrorMessage = createSelector(
    getGetTimezoneError,
    (entity) => get(entity, 'message')
);

export const getTimezone = createSelector(
    getSettingsEntity,
    (entity) => get(entity, 'timezone')
);
